import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import BookingList from '../../../components/Booking/BookingList/BookingList';
import Loader from '../../../components/Common/Loader/Loader';
import { getAllBookings } from '../../../lib/graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class ManualBooking extends Component {

    render() {
        const { formatMessage } = this.props.intl;
        const { bookingDetails, bookingDetails: { loading } } = this.props;
        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.manualBookings)}</h1>
                {!loading && <BookingList bookingDetails={bookingDetails} isManualBooking />}
            </Loader>
        );
    }
}

export default compose(injectIntl,
    withQuery(getAllBookings, {
        name: 'bookingDetails',
        options: (props) => ({
            variables: {
                currentPage: 1,
                searchList: '',
                isManualBooking: true
            },
            fetchPolicy: 'network-only',
            ssr: false
        }),
    }))(ManualBooking);
